import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    search = '',
    maxLevel = -1,
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.industry.getTree, {
        search,
        maxLevel,
    }, options);
    if (error) return { error, status };
    return content || { rows: [] };
};
